import { render, staticRenderFns } from "./ActivitiesByType.vue?vue&type=template&id=622e8c17"
import script from "./ActivitiesByType.vue?vue&type=script&lang=js"
export * from "./ActivitiesByType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports